module.exports = __webpack_public_path__ + "3e0e6619fd35dea70b21fa28368d95c9.mp4";